import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { AppCtrlTemplateDirective } from '../directives/app-ctrl-template.directive';

@Component({
    selector: 'templates-component',
    templateUrl: './templates-component.html',
    styleUrls: ['./templates-component.scss'],
    standalone: false
})
export class TemplatesComponent implements OnInit, AfterViewInit {
  @ViewChildren(AppCtrlTemplateDirective, { read: AppCtrlTemplateDirective })
  templateRefs: QueryList<AppCtrlTemplateDirective>;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter<any>();
  constructor() {}
  ngOnInit(): void {}
  getTemplate(templateName: string) {
    if (this.templateRefs) {
      const templateRef = this.templateRefs
        .toArray()
        .find(x => this.isMatchingTemplateName(x.name, templateName));
      return templateRef ? templateRef.template : undefined;
    }
  }
  private isMatchingTemplateName(name: string, templateName: string): boolean {
    return (
      name && templateName && name.toLowerCase() === templateName.toLowerCase()
    );
  }
  ngAfterViewInit() {}
}
